import { ThemeOptions } from "@mui/material/styles";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#A3CBC8",
      light: "#D4EAE9",
      dark: "#3A8C82",
    },
    secondary: {
      main: "#F8B04B",
      light: "#F7E0BA",
      dark: "#B88337",
    },
    background: {
      default: "#FBF2E9",
    },
    success: {
      main: "#C5CC63",
      light: "#E9E9AF",
      dark: "#787822",
    },
  },
  shape: {
    borderRadius: 10,
  },
};
